export const enum PaymentTypes {
  UPFRONT = 'upfront',
  FINANCED = 'financed',
}

export const enum ContractTypes {
  INSTALLMENT = 'installment',
  SERVICE = 'service',
  PREPAYMENTS = 'prepayments',
}

export const enum BillTypes {
  INSTALLMENT = 'installment',
  DOWN_PAYMENT = 'down_payment',
}

export const enum AnalysisTypes {
  IDENTITY = 'identity',
  FINANCIAL = 'financial',
  BLACKLIST = 'blacklist_customer',
  DEFAULTING = 'defaulting_customer',
}

export const enum BillDetailTypeEnum {
  FINANCING_INTEREST = 'financing_interest',
  AMORTIZATION = 'amortization',
  IOF = 'iof',
  LATE_PAYMENT_INTEREST = 'late_payment_interest',
  LATE_PAYMENT_FINE = 'late_payment_fine',
  FINANCING_INTEREST_REMOVAL = 'financing_interest_removal',
}

export const enum ContactEnum {
  EMAIL = 'email',
  PHONE = 'phone',
}

export const enum FinancedTypeEnum {
  BOLEPIX = 'bolepix',
  CARD = 'card',
}

export const enum AvailabilityTypes {
  ENABLED = 'enabled',
  DISABLED = 'disabled',
  EXPIRED = 'expired',
  ARCHIVED = 'archived',
}

export const enum PaymentMethodConfigurationTypeEnum {
  DOWN_PAYMENT = 'down_payment',
  INSTALLMENT = 'installment',
}

export const enum BillListStatusTypeEnum {
  OVERDUE = 'overdue',
  PAID = 'paid',
  FUTURE = 'future',
  CANCELED = 'canceled',
  CURRENT = 'current',
  REFUNDED = 'refunded',
}

export const enum PaymentMethodEnum {
  CREDIT_CARD = 'credit_card',
  BOLETO = 'boleto',
  PIX = 'pix',
}

export const enum CheckoutTypeEnum {
  DEFAULT = 'default',
  WITHOUT_ADDRESS = 'without_address',
}
